import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { poppins400, poppins500, poppins600 } from 'theme/common.style';
import OwnerCard from 'component/OwnerCard/OwnerCard';
import { getBuyerDetails, getOwnerDetails } from 'api/apiService';
import { BuyersCard } from 'component/BuyersCard/BuyersCard';
import { useHistory } from 'react-router-dom';
import Loading from 'assets/images/loading.png';
export const navigateTo = async (
  item,
  setShowSearchList,
  setRow,
  setBuyerId,
  setShowOwnerCard,
  setOpenOwner,
  setOpen,
  setIsModalOpen,
  setShowBuyerCard,
  setCatSelected,
  history,
  getOwnerInfo,
  getBuyerInfo,
  data,
  setSearchText,
  setActiondone,
  setNoteSelected,
  setTaskBinderId,
  setTaskId,
  setFromSearch
) => {
  setShowSearchList(false);
  setActiondone(true);
  setSearchText('');

  const resetCards = () => {
    setShowOwnerCard(false);
    setShowBuyerCard(false);
    setOpen(false);
    setOpenOwner(false);
    setIsModalOpen(false);
    setCatSelected('');
    setNoteSelected('');
    setTaskBinderId('');
    setTaskId('');
  };
  if (item?.category === 'owner') {
    setFromSearch(false);
    resetCards();
    const ownerResp = await getOwnerInfo();
    const ownerData = ownerResp.userDetails;
    const filteredRow = ownerData?.find(
      (obj) => obj?.user?.userId == item?.userId
    );
    if (filteredRow) {
      setRow(filteredRow);
    }
    setBuyerId(item?.userId);
    setShowOwnerCard(true);
    setShowBuyerCard(false);
    setOpenOwner(true);
    setOpen(true);
    setIsModalOpen(true);
  }

  if (item?.category === 'buyer') {
    resetCards();
    setFromSearch(false);
    const buyerResp = await getBuyerInfo();
    const buyerData = buyerResp.userDetails;
    const filteredRow = buyerData?.find(
      (obj) => obj?.user?.userId == item?.userId
    );
    if (filteredRow) {
      setRow(filteredRow);
    }
    setBuyerId(item?.userId);
    setIsModalOpen(true);
    setShowBuyerCard(true);
    setShowOwnerCard(false);
    setOpenOwner(true);
    setOpen(true);
  }

  if (item?.category === 'appraisal' || item?.category === 'pipeline') {
    resetCards();
    setFromSearch(false);
    history.push({
      pathname: '/pipeline',
      state: {
        userId: item?.userId,
        catSelected: 'ap',
        pipeId: item?.pipelineId,
      },
    });

    setFromSearch(true);
    setCatSelected('ap');
    const ownerResp = await getOwnerInfo();
    const ownerData = ownerResp.userDetails;
    const filteredRow = ownerData?.find(
      (obj) => obj?.user?.userId == item?.userId
    );
    if (filteredRow) {
      setRow(filteredRow);
    }
    setBuyerId(item?.userId);
    setShowOwnerCard(true);
    setShowBuyerCard(false);
    setOpenOwner(true);
    setOpen(true);
    setIsModalOpen(true);
  }

  if (item?.category === 'property') {
    setFromSearch(false);
    resetCards();
    history.push({
      pathname: `/dashboard/view-dashboard/${item?.propertyId}`,
    });
  }

  if (item?.category === 'task') {
    resetCards();
    setFromSearch(true);
    setCatSelected('task');
    setTaskBinderId(item?.binderId);
    setTaskId(item?.taskId);

    if (item?.assigneeUserType === 'Vendor001') {
      const ownerResp = await getOwnerInfo();
      const ownerData = ownerResp.userDetails;
      const filteredRow = ownerData?.find(
        (obj) => obj?.user?.userId == item?.assigneeId
      );
      if (filteredRow) {
        setRow(filteredRow);
      }
      setBuyerId(item?.assigneeId);
      setShowOwnerCard(true);
      setShowBuyerCard(false);
      setOpenOwner(true);
      setOpen(true);
      setIsModalOpen(true);
    }

    if (item?.assigneeUserType === 'Buyer001') {
      const buyerResp = await getBuyerInfo();
      const buyerData = buyerResp.userDetails;
      const filteredRow = buyerData?.find(
        (obj) => obj?.user?.userId == item?.assigneeId
      );
      if (filteredRow) {
        setRow(filteredRow);
      }
      setBuyerId(item?.assigneeId);
      setIsModalOpen(true);
      setShowOwnerCard(false);
      setShowBuyerCard(true);
      setOpenOwner(true);
      setOpen(true);
    }
  }

  if (item?.category === 'notes') {
    resetCards();
    setFromSearch(true);
    setCatSelected('notes');
    setNoteSelected(item?.notesId);

    if (item?.userType === 'Vendor') {
      const ownerResp = await getOwnerInfo();
      const ownerData = ownerResp.userDetails;
      const filteredRow = ownerData?.find(
        (obj) => obj?.user?.userId == item?.userId
      );
      if (filteredRow) {
        setRow(filteredRow);
      }
      setBuyerId(item?.userId);
      setShowOwnerCard(true);
      setShowBuyerCard(false);
      setOpenOwner(true);
      setOpen(true);
      setIsModalOpen(true);
    }

    if (item?.userType === 'Buyer') {
      const buyerResp = await getBuyerInfo();
      const buyerData = buyerResp.userDetails;
      const filteredRow = buyerData?.find(
        (obj) => obj?.user?.userId == item?.userId
      );
      if (filteredRow) {
        setRow(filteredRow);
      }
      setBuyerId(item?.userId);
      setIsModalOpen(true);
      setShowOwnerCard(false);
      setShowBuyerCard(true);
      setOpenOwner(true);
      setOpen(true);
    }
  }
};

function SearchTool({
  hidepopup,
  setHidepopup,
  isMobile,
  matches1300,
  showTabs,
  setShowTabs,
  showResults,
  setShowResults,
  selectedOption,
  options,
  handleOptionSelect,
  getIcon,
  filteredSuggestions,
  categoryMatchCounts,
  searchText,
  showDropdown,
  setShowDropdown,
  setSearchText,
  isSearchLoading,
  setActiondone,
}) {
  //state declaration to call owner/buyer card
  const [selectedBuyerId, setSelectedBuyerId] = useState('');
  const [openOwner, setOpenOwner] = React.useState(false);
  const [isChecked, setIsChecked] = React.useState(false);
  const [position, setPosition] = useState(0);
  const [buyerId, setBuyerId] = React.useState('');
  const [arrayCollection, setArrayCollection] = useState([]);
  const [showBackdrop, setShowBackDrop] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [indexValue, setIndexValue] = useState(null);
  const [isHiddenRightArrow, setIsHiddenRightArrow] = useState(false);
  const [userType, setUserType] = React.useState(false);
  const [properties, setProperties] = useState([]);
  const [row, setRow] = useState({});
  const [showOwnerCard, setShowOwnerCard] = useState(false);
  const [showBuyerCard, setShowBuyerCard] = useState(false);
  const [fromSearch, setFromSearch] = useState(false);
  const [catSelected, setCatSelected] = useState('');
  const [noteSelected, setNoteSelected] = useState();
  const [taskBinderId, setTaskBinderId] = useState('');
  const [taskId, setTaskId] = useState('');
  const [showSearchList, setShowSearchList] = useState(true);

  // for  buyercard
  const [expandFeedback, setExpandFeedback] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(null);
  const history = useHistory();

  const getBuyerInfo = () => {
    return getBuyerDetails().then((resp) => {
      setProperties(resp);
      return resp;
    });
  };

  const getOwnerInfo = () => {
    return getOwnerDetails().then((resp) => {
      setProperties(resp);
      return resp;
    });
  };

  let data = [];
  data = properties?.userDetails
    ? properties?.userDetails || []
    : properties?.data || [];
  const highlightText = (text, searchText) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, 'gi'); // Case-insensitive search
    return text?.replace(
      regex,
      '<span style="background-color: yellow;">$1</span>'
    );
  };

  return (
    <>
      {(showSearchList || searchText != '') && (
        <Paper
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            position: 'absolute',
            top: '58px',
            left: isMobile ? '0' : '-300px',
            height: isMobile ? 'auto' : '600px',
            width: isMobile ? '100%' : matches1300 ? '1200px' : '1030px',
            backgroundColor: '#fff',
            borderRadius: '10px',
            zIndex: 9999,
          }}
        >
          {/* Mobile View: Hamburger Menu */}
          {isMobile && !showTabs && (
            <IconButton
              sx={{ position: 'absolute', top: 10, left: 10 }}
              onClick={() => {
                setShowTabs(true);
                setShowResults(false);
              }}
            >
              <MenuOpenIcon />
            </IconButton>
          )}

          {/* Left Side - Tabs Section */}
          {(isMobile ? showTabs : true) && (
            <List
              sx={{
                minWidth: isMobile ? '100%' : '230px',
                maxWidth: '100%',
                maxHeight: isMobile ? '500px' : 'auto',
                overflowY: isMobile ? 'auto' : 'visible',
                overflowX: 'auto',
                display: isMobile && showResults ? 'none' : 'block',
                backgroundColor: '#FAFAFA',
              }}
            >
              {options.map((tab) => (
                <ListItem
                  button
                  key={tab}
                  onClick={() => {
                    handleOptionSelect(tab);
                    if (isMobile) {
                      setShowResults(true);
                      setShowTabs(false);
                    }
                  }}
                  selected={selectedOption === tab}
                >
                  <ListItemIcon>
                    {getIcon(tab, selectedOption === tab)}
                  </ListItemIcon>
                  <ListItemText
                    primary={tab}
                    primaryTypographyProps={{
                      ...poppins400,
                      color: selectedOption === tab ? '#1976d2' : '#666666',
                    }}
                  />
                </ListItem>
              ))}
            </List>
          )}

          {/* Right Side - Search & Suggestions */}
          {isSearchLoading ? (
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              width={'100%'}
              sx={{ height: isMobile ? '350px' : 'auto' }}
            >
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{
                  height: isMobile ? '100px' : '150px',
                  width: isMobile ? '100px' : '150px',
                }}
              />
            </Box>
          ) : (
            (!isMobile || showResults) && (
              <Box
                sx={{
                  marginTop: isMobile ? 5 : 0,
                  maxHeight: '610px',
                  overflowY: 'auto',
                  minWidth: isMobile ? '250px' : '800px',
                  height: isMobile ? '480px' : '600px',
                  scrollbarWidth: 'thin',
                  borderRadius: '5px',
                  backgroundColor: '#F7F7F7 ',
                  '&::-webkit-scrollbar': {
                    width: '12px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '10px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#888',
                    borderRadius: '10px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#555',
                  },
                }}
              >
                {selectedOption === 'All' ? (
                  Object.keys(filteredSuggestions).length > 0 ? (
                    Object.entries(filteredSuggestions).map(
                      ([category, items]) => (
                        <Box
                          key={category}
                          sx={{ backgroundColor: '#F7F7F7 ' }}
                        >
                          {items.map((item, index) => (
                            <ListItem
                              key={index}
                              onClick={() =>
                                navigateTo(
                                  item,
                                  setShowSearchList,
                                  setRow,
                                  setBuyerId,
                                  setShowOwnerCard,
                                  setOpenOwner,
                                  setOpen,
                                  setIsModalOpen,
                                  setShowBuyerCard,
                                  setCatSelected,
                                  history,
                                  getOwnerInfo,
                                  getBuyerInfo,
                                  data,
                                  setSearchText,
                                  setActiondone,
                                  setNoteSelected,
                                  setTaskBinderId,
                                  setTaskId,
                                  setFromSearch
                                )
                              }
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                '&:hover': {
                                  backgroundColor: '#F2F2F2',
                                },
                              }}
                            >
                              <Box
                                display={'flex'}
                                alignItems={'center'}
                                justifyContent={'space-between'}
                                width="100%"
                              >
                                <Box
                                  display={'flex'}
                                  alignItems={'center'}
                                  gap={1}
                                >
                                  {getIcon(
                                    item.category?.charAt(0).toUpperCase() +
                                      item.category?.slice(1),
                                    selectedOption === item.category
                                  )}
                                  {(item?.category == 'owner' ||
                                    item?.category == 'buyer' ||
                                    item?.category == 'agent' ||
                                    item?.category == 'solicitor') && (
                                    <Typography
                                      sx={{
                                        ...poppins500,
                                        color: '#666666',
                                        fontSize: isMobile ? '12px' : '16px',
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          `${item?.userName} ${item?.userSurName}`,
                                          searchText
                                        ),
                                      }}
                                    />
                                  )}
                                  {(item?.category === 'property' ||
                                    item?.category === 'appraisal' ||
                                    item?.category === 'campaign') && (
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        ...poppins500,
                                        color: '#666666',
                                        fontSize: isMobile ? '12px' : '16px',
                                        wordWrap: 'break-word',
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word',
                                        maxWidth: isMobile ? '220px' : '600px',
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          item?.address,
                                          searchText
                                        ),
                                      }}
                                    />
                                  )}

                                  {item?.category == 'notes' && (
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        ...poppins500,
                                        color: '#666666',
                                        fontSize: isMobile ? '12px' : '16px',
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          item?.subject,
                                          searchText
                                        ),
                                      }}
                                    />
                                  )}

                                  {item?.category == 'task' && (
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        ...poppins500,
                                        color: '#666666',
                                        fontSize: isMobile ? '12px' : '16px',
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          item?.heading || 'sample task',
                                          searchText
                                        ),
                                      }}
                                    />
                                  )}

                                  {item?.category == 'pipeline' && (
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        ...poppins500,
                                        color: '#666666',
                                        fontSize: isMobile ? '12px' : '16px',
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          item?.heading || item?.pipelineName,
                                          searchText
                                        ),
                                      }}
                                    />
                                  )}
                                </Box>

                                {(item?.category === 'buyer' ||
                                  item?.category === 'owner') && (
                                  <Button
                                    sx={{
                                      cursor: 'default',
                                      pointerEvents: 'none',
                                      color:
                                        item.category === 'buyer'
                                          ? '#6C2AD2'
                                          : '#4CA4D6',
                                      borderColor:
                                        item.category === 'buyer'
                                          ? '#6C2AD2'
                                          : '#4CA4D6',
                                      width: isMobile ? '30px' : '80px',
                                      fontSize: isMobile ? '8px' : '14px',
                                    }}
                                    variant="outlined"
                                  >
                                    #{item?.category}
                                  </Button>
                                )}

                                {(item?.category === 'property' ||
                                  item?.category === 'campaign' ||
                                  item?.category === 'appraisal') && (
                                  <Button
                                    sx={{
                                      cursor: 'default',
                                      pointerEvents: 'none',
                                      color: '#373737',
                                      borderColor: '#8E8E8E',
                                      width: isMobile ? '85px' : '120px',
                                      fontSize: isMobile ? '8px' : '14px',
                                    }}
                                    variant="outlined"
                                  >
                                    {item?.tag}
                                  </Button>
                                )}
                              </Box>

                              {(item?.category === 'property' ||
                                item?.category === 'appraisal' ||
                                item?.category === 'campaign' ||
                                item?.category === 'notes') && (
                                <Typography
                                  sx={{
                                    ...poppins400,
                                    color: '#666666',
                                    fontSize: '12px',
                                    paddingLeft: 4,
                                    paddingTop: 1,
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal',
                                    overflowWrap: 'break-word',
                                    maxWidth: isMobile ? '240px' : '600px',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: highlightText(
                                      `${item?.userName} ${item?.userSurName} - ${item?.address}`,
                                      searchText
                                    ),
                                  }}
                                />
                              )}

                              {item?.category == 'task' && (
                                <Typography
                                  variant="h6"
                                  sx={{
                                    ...poppins400,
                                    color: '#666666',
                                    fontSize: '12px',
                                    paddingLeft: 4,
                                    paddingTop: 1,
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal',
                                    overflowWrap: 'break-word',
                                    maxWidth: isMobile ? '240px' : '630px',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: highlightText(
                                      `${
                                        item?.userId === item?.creatorId
                                          ? `${item?.assigneeName} ${item?.assigneeSurName}`
                                          : item?.userId === item?.assigneeId
                                          ? `${item?.creatorName} ${item?.creatorSurName}`
                                          : ''
                                      } - ${item?.propertyAddress}`,
                                      searchText
                                    ),
                                  }}
                                />
                              )}

                              {item?.category === 'notes' && (
                                <Typography
                                  sx={{
                                    ...poppins400,
                                    color: '#666666',
                                    fontSize: '12px',
                                    paddingLeft: 4,
                                  }}
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      ...poppins600,
                                      fontSize: 'inherit',
                                    }}
                                  >
                                    Notes:
                                  </Box>{' '}
                                  {item?.notes}
                                </Typography>
                              )}

                              {item?.category === 'task' && (
                                <Typography
                                  sx={{
                                    ...poppins400,
                                    color: '#666666',
                                    fontSize: '12px',
                                    paddingLeft: 4,
                                  }}
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      ...poppins600,
                                      fontSize: 'inherit',
                                    }}
                                  >
                                    Tasks:
                                  </Box>{' '}
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: highlightText(
                                        item?.description ||
                                          'this is the sample task available',
                                        searchText
                                      ),
                                    }}
                                  />
                                </Typography>
                              )}
                            </ListItem>
                          ))}
                          <Typography
                            sx={{
                              color: '#666666',
                              paddingLeft: 6,
                              ...poppins400,
                              fontSize: isMobile ? '10px' : '12px',
                            }}
                          >
                            {categoryMatchCounts[category] || 0} match
                            {(categoryMatchCounts[category] || 0) > 1
                              ? 'es'
                              : ''}{' '}
                            found in{' '}
                            <Box
                              component="span"
                              sx={{
                                ...poppins600,
                                fontSize: isMobile ? '10px' : '12px',
                                color: '#666666',
                              }}
                            >
                              {category.charAt(0).toUpperCase() +
                                category.slice(1)}
                            </Box>
                          </Typography>
                        </Box>
                      )
                    )
                  ) : (
                    <Box
                      sx={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          ...poppins400,
                          color: '#666666',
                          fontSize: '16px',
                          textAlign: 'center',
                        }}
                      >
                        No results found
                      </Typography>
                    </Box>
                  )
                ) : filteredSuggestions.length > 0 ? (
                  filteredSuggestions.map((item, index) => (
                    <ListItem
                      key={index}
                      onClick={() =>
                        navigateTo(
                          item,
                          setShowSearchList,
                          setRow,
                          setBuyerId,
                          setShowOwnerCard,
                          setOpenOwner,
                          setOpen,
                          setIsModalOpen,
                          setShowBuyerCard,
                          setCatSelected,
                          history,
                          getOwnerInfo,
                          getBuyerInfo,
                          data,
                          setSearchText,
                          setActiondone,
                          setNoteSelected,
                          setTaskBinderId,
                          setTaskId,
                          setFromSearch
                        )
                      }
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: 0.5,
                        '&:hover': {
                          backgroundColor: '#F2F2F2',
                        },
                      }}
                    >
                      <Box
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'space-between'}
                        width="100%"
                      >
                        <Box display={'flex'} alignItems={'center'} gap={1}>
                          {getIcon(
                            item.category?.charAt(0).toUpperCase() +
                              item.category?.slice(1),
                            selectedOption === item.category
                          )}
                          {(item?.category == 'owner' ||
                            item?.category == 'buyer' ||
                            item?.category == 'agent' ||
                            item?.category == 'solicitor') && (
                            <Typography
                              variant="h6"
                              sx={{
                                ...poppins500,
                                color: '#666666',
                                fontSize: isMobile ? '12px' : '16px',
                              }}
                              dangerouslySetInnerHTML={{
                                __html: highlightText(
                                  `${item?.userName} ${item?.userSurName}`,
                                  searchText
                                ),
                              }}
                            />
                          )}

                          {(item?.category === 'property' ||
                            item?.category === 'appraisal' ||
                            item?.category === 'campaign') && (
                            <Typography
                              variant="h6"
                              sx={{
                                ...poppins500,
                                color: '#666666',
                                fontSize: isMobile ? '12px' : '16px',
                                wordWrap: 'break-word',
                                whiteSpace: 'normal',
                                overflowWrap: 'break-word',
                                maxWidth: isMobile ? '220px' : '630px',
                              }}
                              dangerouslySetInnerHTML={{
                                __html: highlightText(
                                  item?.address,
                                  searchText
                                ),
                              }}
                            />
                          )}
                          {item?.category == 'notes' && (
                            <Typography
                              variant="h6"
                              sx={{
                                ...poppins500,
                                color: '#666666',
                                fontSize: isMobile ? '12px' : '16px',
                              }}
                              dangerouslySetInnerHTML={{
                                __html: highlightText(
                                  item?.subject,
                                  searchText
                                ),
                              }}
                            />
                          )}
                          {item?.category == 'task' && (
                            <Typography
                              variant="h6"
                              sx={{
                                ...poppins500,
                                color: '#666666',
                                fontSize: isMobile ? '12px' : '16px',
                              }}
                              dangerouslySetInnerHTML={{
                                __html: highlightText(
                                  item?.heading || 'sample note',
                                  searchText
                                ),
                              }}
                            />
                          )}
                          {item?.category == 'pipeline' && (
                            <Typography
                              variant="h6"
                              sx={{
                                ...poppins500,
                                color: '#666666',
                                fontSize: isMobile ? '12px' : '16px',
                              }}
                              dangerouslySetInnerHTML={{
                                __html: highlightText(
                                  item?.heading || item?.pipelineName,
                                  searchText
                                ),
                              }}
                            />
                          )}
                        </Box>
                        {(item?.category === 'buyer' ||
                          item?.category === 'owner') && (
                          <Button
                            sx={{
                              cursor: 'default',
                              pointerEvents: 'none',
                              color:
                                item.category === 'buyer'
                                  ? '#6C2AD2'
                                  : '#4CA4D6',
                              borderColor:
                                item.category === 'buyer'
                                  ? '#6C2AD2'
                                  : '#4CA4D6',
                              width: isMobile ? '30px' : '80px',
                              fontSize: isMobile ? '8px' : '14px',
                            }}
                            variant="outlined"
                          >
                            #{item?.category}
                          </Button>
                        )}
                        {(item?.category === 'property' ||
                          item?.category === 'campaign' ||
                          item?.category === 'appraisal') && (
                          <Button
                            sx={{
                              cursor: 'default',
                              pointerEvents: 'none',
                              color: '#373737',
                              borderColor: '#8E8E8E',
                              width: isMobile ? '85px' : '120px',
                              fontSize: isMobile ? '8px' : '14px',
                            }}
                            variant="outlined"
                          >
                            {item?.tag}
                          </Button>
                        )}
                      </Box>
                      {(item?.category === 'property' ||
                        item?.category === 'appraisal' ||
                        item?.category === 'campaign' ||
                        item?.category === 'notes') && (
                        <Typography
                          sx={{
                            ...poppins400,
                            color: '#666666',
                            fontSize: '12px',
                            paddingLeft: 4,
                            paddingTop: 1,
                            wordWrap: 'break-word',
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                            maxWidth: isMobile ? '240px' : '630px',
                          }}
                          dangerouslySetInnerHTML={{
                            __html: highlightText(
                              `${item?.userName} ${item?.userSurName} - ${item?.address}`,
                              searchText
                            ),
                          }}
                        />
                      )}
                      {item?.category == 'task' && (
                        <Typography
                          variant="h6"
                          sx={{
                            ...poppins400,
                            color: '#666666',
                            fontSize: '12px',
                            paddingLeft: 4,
                            paddingTop: 1,
                            wordWrap: 'break-word',
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                            maxWidth: isMobile ? '240px' : '630px',
                          }}
                          dangerouslySetInnerHTML={{
                            __html: highlightText(
                              `${
                                item?.userId === item?.creatorId
                                  ? `${item?.assigneeName} ${item?.assigneeSurName}`
                                  : item?.userId === item?.assigneeId
                                  ? `${item?.creatorName} ${item?.creatorSurName}`
                                  : ''
                              } - ${item?.propertyAddress}`,
                              searchText
                            ),
                          }}
                        />
                      )}
                      {item?.category === 'notes' && (
                        <Typography
                          sx={{
                            ...poppins400,
                            color: '#666666',
                            fontSize: '12px',
                            paddingLeft: 4,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              ...poppins600,
                              fontSize: 'inherit',
                            }}
                          >
                            Notes:
                          </Box>{' '}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: highlightText(
                                item?.notes || '',
                                searchText
                              ),
                            }}
                          />
                        </Typography>
                      )}
                      {item?.category === 'task' && (
                        <Typography
                          sx={{
                            ...poppins400,
                            color: '#666666',
                            fontSize: '12px',
                            paddingLeft: 4,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              ...poppins600,
                              fontSize: 'inherit',
                            }}
                          >
                            Tasks:
                          </Box>{' '}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: highlightText(
                                item?.description ||
                                  'this is the sample task available',
                                searchText
                              ),
                            }}
                          />
                        </Typography>
                      )}
                    </ListItem>
                  ))
                ) : (
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins400,
                        color: '#666666',
                        fontSize: '16px',
                        textAlign: 'center',
                      }}
                    >
                      No results found
                    </Typography>
                  </Box>
                )}
              </Box>
            )
          )}
        </Paper>
      )}
      {showOwnerCard && (
        <OwnerCard
          selectedBuyerId={selectedBuyerId}
          setSelectedBuyerId={setSelectedBuyerId}
          openOwner={openOwner}
          setOpenOwner={setOpenOwner}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          arrayCollection={arrayCollection}
          setPosition={setPosition}
          setBuyerId={setBuyerId}
          setArrayCollection={setArrayCollection}
          showBackdrop={showBackdrop}
          setShowBackDrop={setShowBackDrop}
          open={openOwner}
          setOpen={setOpenOwner}
          buyerId={buyerId}
          setOpenBuyer={setOpen}
          openBuyer={open}
          userType={userType}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          index={indexValue}
          isHiddenRightArrow={isHiddenRightArrow}
          setIsHiddenRightArrow={setIsHiddenRightArrow}
          data={data}
          position={position}
          setUserType={setUserType}
          rowData={row}
          setFromSearch={setFromSearch}
          {...(catSelected === 'task' || catSelected === 'notes'
            ? { fromSearch, catSelected, noteSelected, taskBinderId, taskId }
            : { fromSearch, catSelected: 'owner' })}
        />
      )}
      {showBuyerCard && (
        <BuyersCard
          setSelectedBuyerId={setSelectedBuyerId}
          selectedBuyerId={selectedBuyerId}
          showBackdrop={showBackdrop}
          setShowBackDrop={setShowBackDrop}
          isPopupOpen={isPopupOpen}
          buyersId={buyerId}
          openOwner={openOwner}
          setOpenOwner={setOpenOwner}
          open={open}
          row={row}
          userType={userType}
          setOpen={setOpen}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          index={indexValue}
          expandFeedback={expandFeedback}
          setExpandFeedback={setExpandFeedback}
          isHiddenRightArrow={isHiddenRightArrow}
          setIsHiddenRightArrow={setIsHiddenRightArrow}
          position={position}
          arrayCollection={arrayCollection}
          data={data}
          buyerId={buyerId}
          setBuyerId={setBuyerId}
          setPosition={setPosition}
          setArrayCollection={setArrayCollection}
          rowData={row}
          setFromSearch={setFromSearch}
          {...(catSelected === 'task' || catSelected === 'notes'
            ? { fromSearch, catSelected, noteSelected, taskBinderId, taskId }
            : { fromSearch, catSelected: 'buyer' })}
        />
      )}
    </>
  );
}

export default SearchTool;
